import {
  VIEW_MODES,
  HEATMAP_COLORS,
  COLDMAP_COLORS,
  HEATMAP_OPACITY
} from '@aytm/app/stats/page/question-views/hm/components/chart/lib/constants'
import { createSvgRoot } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-root'
import { getSvgDefs } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/svg-defs'
import {
  drawContours,
  getContourStyles
} from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/views/contours'

export const drawHeatmap = (container, options) => {
  const { id, answer, viewMode, image, scale, batches, config, width, height } = options
  const imageHeight = image?.original?.height

  if (!answer?.heatmap?.contours || !answer?.heatmap?.levels) return null

  const svg = createSvgRoot(container, { id, viewMode, width, height, scale })

  const defs = svg.append('defs')
  defs.html(getSvgDefs(id, viewMode))

  const group = svg.append('g').attr('id', `svg-${viewMode}-${id}-group`).style('opacity', 0.8)

  const { contours, levels } = answer.heatmap

  const defaultColors = viewMode === VIEW_MODES.COLDMAP ? COLDMAP_COLORS : HEATMAP_COLORS

  const { colors, opacityValues, isOnePinTypeFiltered } = getContourStyles(
    config,
    batches,
    defaultColors,
    HEATMAP_OPACITY
  )

  drawContours(group, {
    id,
    contours,
    levels,
    imageHeight,
    colors,
    opacityValues,
    isOnePinTypeFiltered
  })

  return null
}
